'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Heading } from '@petsmart-ui/sparky';
import { type ReactElement, useState } from 'react';
import { RemoveCardModal } from '../RemoveCardModal';
import { AddPaymentForm } from './AddPaymentForm';
import { EditPaymentForm } from './EditPaymentForm';
import type { PaymentFormProps } from './types';
import './PaymentForm.scss';
export function PaymentForm(t0) {
  const $ = _c(33);
  const {
    title: t1,
    subtitle: t2,
    isDefaultCheckDisabled,
    isDefaultCheckChecked,
    hideDefaultCheckbox,
    setBillingAddressAsDefaultShippingInMarketOnly,
    editPaymentData,
    onCloseForm,
    onSuccess,
    onError,
    defaultAddressId,
    onEditSubmit,
    onAddressValidationApiError,
    disableUntilDirty,
    addAddressIconSize,
    onRemoveCardClick,
    onExperianModalVisibilityChange: t3,
    onClearError,
    hideCancelCta,
    submitCtaText
  } = t0;
  const title = t1 === undefined ? "Payments" : t1;
  const subtitle = t2 === undefined ? "Add credit or debit card" : t2;
  const onExperianModalVisibilityChange = t3 === undefined ? _temp : t3;
  const [openModal, setOpenModal] = useState(false);
  let t4;
  if ($[0] !== title) {
    t4 = title && <Heading tagName="h5" data-testid="payment-form-title">{title}</Heading>;
    $[0] = title;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== editPaymentData || $[3] !== subtitle) {
    t5 = subtitle && <Heading tagName="h6" size="body-lg-bold" data-testid="payment-form-subtitle" className={editPaymentData ? "payment-form__subtitle" : ""}>{editPaymentData ? "Edit card" : subtitle}</Heading>;
    $[2] = editPaymentData;
    $[3] = subtitle;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== addAddressIconSize || $[6] !== defaultAddressId || $[7] !== disableUntilDirty || $[8] !== editPaymentData || $[9] !== hideCancelCta || $[10] !== hideDefaultCheckbox || $[11] !== isDefaultCheckChecked || $[12] !== isDefaultCheckDisabled || $[13] !== onAddressValidationApiError || $[14] !== onClearError || $[15] !== onCloseForm || $[16] !== onEditSubmit || $[17] !== onError || $[18] !== onExperianModalVisibilityChange || $[19] !== onSuccess || $[20] !== setBillingAddressAsDefaultShippingInMarketOnly || $[21] !== submitCtaText) {
    t6 = editPaymentData ? <EditPaymentForm isDefaultCheckDisabled={isDefaultCheckDisabled || false} editPaymentData={editPaymentData} onCloseForm={onCloseForm} onSuccess={isDefault => onSuccess({
      isEdit: true,
      isDefault
    })} onError={onError} onClearError={onClearError} onSubmit={onEditSubmit} onAddressValidationApiError={onAddressValidationApiError} disableUntilDirty={disableUntilDirty} addAddressIconSize={addAddressIconSize} defaultAddressId={defaultAddressId} onExperianModalVisibilityChange={onExperianModalVisibilityChange} /> : <AddPaymentForm isDefaultCheckDisabled={isDefaultCheckDisabled || false} isDefaultCheckChecked={isDefaultCheckChecked || false} hideDefaultCheckbox={hideDefaultCheckbox} setBillingAddressAsDefaultShippingInMarketOnly={setBillingAddressAsDefaultShippingInMarketOnly || false} onCloseForm={onCloseForm} onSuccess={args => onSuccess({
      isEdit: false,
      isDefault: args?.isDefault,
      addressToLink: args?.addressToLink
    })} onError={onError} onClearError={onClearError} defaultAddressId={defaultAddressId} addAddressIconSize={addAddressIconSize} onExperianModalVisibilityChange={onExperianModalVisibilityChange} onAddressValidationApiError={onAddressValidationApiError} hideCancelCta={hideCancelCta} submitCtaText={submitCtaText} />;
    $[5] = addAddressIconSize;
    $[6] = defaultAddressId;
    $[7] = disableUntilDirty;
    $[8] = editPaymentData;
    $[9] = hideCancelCta;
    $[10] = hideDefaultCheckbox;
    $[11] = isDefaultCheckChecked;
    $[12] = isDefaultCheckDisabled;
    $[13] = onAddressValidationApiError;
    $[14] = onClearError;
    $[15] = onCloseForm;
    $[16] = onEditSubmit;
    $[17] = onError;
    $[18] = onExperianModalVisibilityChange;
    $[19] = onSuccess;
    $[20] = setBillingAddressAsDefaultShippingInMarketOnly;
    $[21] = submitCtaText;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== editPaymentData || $[24] !== onCloseForm || $[25] !== onRemoveCardClick || $[26] !== openModal) {
    t7 = editPaymentData && <><div className="payment-form__remove-button" data-testid="payment-form-remove-button"><Button text="Remove card" variant="link" onClick={() => onRemoveCardClick ? onRemoveCardClick() : setOpenModal(true)} /></div><RemoveCardModal currentPayment={editPaymentData} modalOpen={openModal} modalClose={hideForm => {
        setOpenModal(false);
        if (hideForm) {
          onCloseForm();
        }
      }} /></>;
    $[23] = editPaymentData;
    $[24] = onCloseForm;
    $[25] = onRemoveCardClick;
    $[26] = openModal;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7) {
    t8 = <div className="payment-form" data-testid="payment-form">{t4}{t5}{t6}{t7}</div>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  return t8;
}
function _temp() {}